import { all, takeEvery, takeLatest, put, fork } from "redux-saga/effects";

import axios from "./initialize";
import { Modal } from "antd";
import {
  ExclamationCircleOutlined,
  CheckCircleFilled,
  WarningFilled
} from "@ant-design/icons";

import {
  GET_APP_INSTANCE_SETTINGS_DETAILS,
  ADD_APP_INSTANCE_ROLE,
  DELETE_APP_INSTANCE_ROLE,
  GET_APP_INSTANCE_ROLES,
  GET_APP_INSTANCE_ROLE_PERMISSIONS,
  UPDATE_APP_INSTANCE_ROLE,
  ASSIGN_APP_ROLE_TO_USER,
  SET_MODAL_POPUP,
  ADD_APP_INSTANCE_SETTINGS_JSON,
  SAVE_APP_INSTANCE_API_KEY,
  GET_APP_INSTANCE_API_KEY,
  GET_ASSIGN_INSTANCE_USER_ROLES,
  GET_APP_INSTANCE_DETAILS,
  ADD_APP_INSTANCE_UI_PROPERTIES,
  APP_INSTANCE_UI_PROPERTIES,
  DELETE_APP_INSTANCE_UI_PROPERTIES,
  GET_APP_ROLES_INSTANCE_ROLES,
  GET_APP_INSTANCE_CONNECTOR_DETAILS,
  LINK_APP_TO_CONNECTOR,
  GET_LINKED_APP_INSTANCE_CONNECTOR,
  GET_CONNECTOR_INSTANCE_SETTINGS_DETAILS,
  ADD_CONNECTOR_INSTANCE_SETTINGS_JSON,
  GET_APP_INSTANCE_ROLE_PERMISSIONS_LIST,
  GET_APP_INSTANCE_API_KEYS,
  DELETE_APP_INSTANCE_API_KEY,
  UPDATE_APP_INSTANCE_API_KEY,
} from "redux/constants/appInstance";

import {
  appSettingsJson,
  connectorSettingsJson,
  showAppInstanceMessage,
  appInstanceRoles,
  appRolesInstanceRoles,
  setAddEdit,
  appInstanceRolePermissions,
  setModalRolePopUpData,
  appInstanceApiKey,
  appInstanceUserRoles,
  appInstaneData,
  appInstanceUiPropertiesJson,
  linkedAppInstaneData,
  appInstanceApiKeys
} from "redux/actions/appInstance";
import { API_BASE_DEVELOPER_APP, API_BASE_URL } from "configs/AppConfig";

import { AUTH_TOKEN } from "../constants/Auth";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import user from "redux/reducers/user";
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";

export function* getApplicationSettingsDetail() {
  yield takeEvery(GET_APP_INSTANCE_SETTINGS_DETAILS, function* ({ payload }) {
    const custom = payload?.custom?"custom" : "";
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${payload?.appInstanceId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            accountId: localStorage.getItem("accountId"),
            appInstanceId: payload?.appInstanceId,
            accountUserId: localStorage.getItem("accountUserId"),
          },
        }
      );

      if (response.status === 200) {
        const traceObj ={
          type: `get_application_${custom}_settings_detail`,
          event: 'click',
          message: `Application ${custom} settings detail retrieved for appInstanceId or subscriptionId=${payload?.appInstanceId}`,
          status: `Application ${custom} settings detail retrieve successfully `,
          action: `Clicked to get application ${custom} settings details`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        if (response?.data !== null) {
          yield put(appSettingsJson(response.data));
        } else {
          yield put(appSettingsJson({}));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `get_application_${custom}_settings_detail`,
        event: 'click',
        message: `Failed to pplication ${custom} settings detail for appInstanceId or subscriptionId=${payload?.appInstanceId}`,
        status: `Failed to retrieve application ${custom} settings details`,
        action: `Clicked to get application ${custom} settings details`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export function* getConnectorSettingsDetail() {
  yield takeEvery(
    GET_CONNECTOR_INSTANCE_SETTINGS_DETAILS,
    function* ({ payload }) {
      try {
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${payload?.appInstanceId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              "Access-Control-Allow-Origin": "*",
              Accept: "application/json",
              "Content-Type": "application/json",
              accountId: localStorage.getItem("accountId"),
              appInstanceId: payload?.appInstanceId,
              accountUserId: localStorage.getItem("accountUserId"),
            },
          }
        );

        if (response.status === 200) {
          const traceObj ={
            type: `get_connector_settings_detail`,
            event: 'click',
            message: `Connector details retrieved for appInstanceId or subscriptionId=${payload?.appInstanceId} and appId=${payload?.appId}`,
            status: `Connector settings detail retrieve successfully `,
            action: `Clicked get connector settings details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
          if (response?.data !== null) {
            yield put(connectorSettingsJson(response.data));
          }
        }
      } catch (error) {
        const traceObj ={
          type: `get_connector_settings_details`,
          event: 'click',
          message: `Failed to retrieve connector details for appInstanceId or subscriptionId=${payload?.appInstanceId} and appId=${payload?.appId}`,
          status: `Failed to retrieve connector settings details`,
          action: `Clicked get connector settings details`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        console.log(error);

        yield put(showAppInstanceMessage(error.response));
      }
    }
  );
}

export function* getAppInstanceDetails() {
  yield takeEvery(GET_APP_INSTANCE_DETAILS, function* ({ payload }) {
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app/appInstance/${payload?.appInstanceId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            accountId: localStorage.getItem("accountId"),
            appInstanceId: payload?.appInstanceId,
            accountUserId: localStorage.getItem("accountUserId"),
          },
        }
      );

      if (response.status === 200) {
        const traceObj ={
          type: `get_app_instance_subscription_details`,
          event: 'click',
          message: `AppInstance or subscription details retrieved for appInstanceId or subscriptionId=${payload?.appInstanceId}`,
          status: `AppInstance or subscription details retrieve successfully `,
          action: `Clicked get appInstance Subscription details `,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        if (response?.data !== null) {
          yield put(appInstaneData(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `get_app_instance_subscription_details`,
        event: 'click',
        message: `Failed to retrieve appInstance or subscription details for appInstanceId or subscriptionId=${payload?.appInstanceId}`,
        status: `Failed to retrieve appInstance details`,
        action: `Clicked get appInstance Subscription details `,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);

      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export function* addAppInstanceRole() {
  yield takeEvery(ADD_APP_INSTANCE_ROLE, function* ({ payload }) {
    const { values, checkedPermission } = payload;

    try {
      //const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:values?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRole`,
        values,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `add_app_instance_role`,
          event: 'click',
          message: `AppInstance role added successfully  for id=${res?.data?.appInstanceRole?.id} and appInstanceId=${values?.appInstanceId}`,
          status: `AppInstance role added successfully `,
          action: `Clicked add appInstance role `,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        var appInstanceRolePermissionData = {};
        if (res.data.appInstanceRole) {
          Modal.success({
            title: t("impaqx.adminApp.appInstanceRoleCreateMessage"),
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          const appInstanceRoleResponse = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRoles?appInstanceId=${
              res?.data?.appInstanceRole?.appInstanceId
            }&query=${payload?.query}&sortfield=${
              payload?.sorter?.field
            }&sortorder=${payload?.sorter?.order}&page=${
              payload?.pagination?.current - 1
            }&size=${payload?.pagination?.pageSize}`,
            config
          );
          if (appInstanceRoleResponse.status === 200) {
            yield put(appInstanceRoles(appInstanceRoleResponse.data));
            yield put(setAddEdit(false));
          }
          appInstanceRolePermissionData["appInstanceRoleId"] =
            res.data.appInstanceRole.id;
          appInstanceRolePermissionData["appInstanceId"] =
            res.data.appInstanceRole.appInstanceId;
          appInstanceRolePermissionData["appId"] =
            res.data.appInstanceRole.appId;
          appInstanceRolePermissionData["userCreated"] =
            res.data.appInstanceRole.userCreated;
          appInstanceRolePermissionData["userUpdated"] =
            res.data.appInstanceRole.userCreated;
          appInstanceRolePermissionData["checkedPermission"] =
            checkedPermission;
          const response = yield axios.post(
            `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRolePermission`,
            appInstanceRolePermissionData,
            config
          );
          if (response.status === 200) {
            //	yield put(apps(response.data));
          }
          //});
        }
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_instance_role`,
        event: 'click',
        message: `Failed to add appInstance role name=${values?.name} and appInstanceId=${values?.appInstanceId}`,
        status: `Failed to add appInstance role`,
        action: `Clicked add app instance role `,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err?.response));
    }
  });
}

export function* updateAppInstanceRole() {
  yield takeEvery(UPDATE_APP_INSTANCE_ROLE, function* ({ payload }) {
    const { values, checkedPermission } = payload;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:values?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRole/${values.id}`,
        values,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `update_app_instance_role`,
          event: 'click',
          message: `AppInstance role updated successfully  for id=${values.id} and appInstanceId=${values?.appInstanceId}`,
          status: `AppInstance role updated successfully `,
          action: `Clicked update app instance role `,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        //const response = yield  axios.get(`${API_BASE_DEVELOPER_APP}/developerApp/appDefaultUserRoles?appId=${res?.data?.appId}&query=${payload?.query}&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current-1}&size=${payload?.pagination?.pageSize}`);
        //if (response.status===200) {
        var appInstanceRolePermissionData = {};
        appInstanceRolePermissionData["appInstanceRoleId"] =
          res.data.appInstanceRole.id;
        // appDefaultUserRolePermissionData["status"]="ACTIVE";
        appInstanceRolePermissionData["userCreated"] =
          res.data.appInstanceRole.userCreated;
        appInstanceRolePermissionData["userUpdated"] =
          res.data.appInstanceRole.userCreated;
        appInstanceRolePermissionData["appInstanceId"] =
          res.data.appInstanceRole.appInstanceId;
        appInstanceRolePermissionData["appId"] = res.data.appInstanceRole.appId;

        // Object.keys(checkedPermission).forEach(function(appPermissionId) {
        // 	appDefaultUserRolePermissionData["appPermissionsId"]=appPermissionId;
        appInstanceRolePermissionData["checkedPermission"] = checkedPermission;
        const response = yield axios.post(
          `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRolePermission`,
          appInstanceRolePermissionData,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${values.roleName}  ${t(
              "impaqx.adminApp.updatePermissionMessage"
            )}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          const appRoleResponse = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRoles?appInstanceId=${
              res?.data?.appInstanceRole?.appInstanceId
            }&query=${payload?.query}&sortfield=${
              payload?.sorter?.field
            }&sortorder=${payload?.sorter?.order}&page=${
              payload?.pagination?.current - 1
            }&size=${payload?.pagination?.pageSize}`,
            config
          );
          if (appRoleResponse.status === 200) {
            yield put(appInstanceRoles(appRoleResponse.data));
            yield put(setAddEdit(false));
          }        }
        //});
        //yield put(appRoles(response.data));

        //	}
      }
    } catch (error) {
      const traceObj ={
        type: `update_app_instance_role`,
        event: 'click',
        message: `Failed to update appInstance role for id=${values.id} and appInstanceId=${values?.appInstanceId}`,
        status: `Failed to update appInstance role`,
        action: `Clicked update app instance role `,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export function* deleteAppRole() {
  yield takeEvery(DELETE_APP_INSTANCE_ROLE, function* ({ payload }) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appId:payload?.appId,
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRole/${payload.id}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `delete_app_role`,
          event: 'click',
          message: `App role deleted successfully  for id=${payload.id} and appInstanceId=${payload?.appInstanceId}`,
          status: `App role deleted successfully `,
          action: `Clicked delete app role `,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        //yield put(showAccountMessage(res));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRoles?appInstanceId=${
            payload?.appInstanceId
          }&query=${payload?.query}&sortfield=${
            payload?.sorter?.field
          }&sortorder=${payload?.sorter?.order}&page=${
            payload?.pagination?.current - 1
          }&size=${payload?.pagination?.pageSize}`,
          config
        );
        if (response.status === 200) {
          Modal.success({
            title: `${payload.roleName}  ${t(
              "impaqx.adminApp.roleDeleteMessage"
            )}`,
            icon: <CheckCircleFilled />,
            okText: "Close",
            //cancelText: 'Cancel',
            onOk() {
              //deleteApp(id);
            },
          });
          yield put(appInstanceRoles(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `delete_app_role`,
        event: 'click',
        message: ` Failed to delete app role for id=${payload.id} and appInstanceId=${payload?.appInstanceId}`,
        status: `Failed to delete app role`,
        action: `Clicked delete app role `,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);
      if(error?.response?.status==403)
      Modal.error({
        title: t("impaqx.adminApp.roleDeletedErrorMessage"),
        icon: <WarningFilled />,
        okText: t("impaqx.adminApp.close"),
        //cancelText: 'Cancel',
        onOk() {
          //deleteApp(id);
        },
      });
      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export function* getAppInstanceRoles() {
  yield takeEvery(GET_APP_INSTANCE_ROLES, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const query=localStorage.getItem("query");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRoles?appInstanceId=${
          payload?.appInstanceId
        }&appId=${payload?.appId}&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_app_instance_roles`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
              status: `AppInstance roles retrieve successfully `,
              action: `Search appInstance roles`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_app_instance_roles`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for appInstanceId=${payload?.appInstanceId}`,
              status: `App instance roles retrieve successfully `,
              action: `Clicked appInstance roles `,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        yield put(appInstanceRoles(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_app_instance_roles`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance roles `,
            action: `Search appInstance roles`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_instance_roles`,
            event: 'click',
            message: `0 results found for appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance roles`,
            action: `Clicked appInstance roles `,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAppRolesInstanceRoles() {
  yield takeLatest(GET_APP_ROLES_INSTANCE_ROLES, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const query = localStorage.getItem("query");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appRolesInstanceRoles?appInstanceId=${
          payload?.appInstanceId
        }&userType=${payload?.userType}&appId=${payload?.appId}&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_app_roles_instance_roles`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for Keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
              status: `App rolesInstance roles retrieve successfully `,
              action: `Search appInstance Roles`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
        const traceObj ={
          type: `get_app_roles_instance_roles`,
          event: 'click',
          message: `${res?.data?.totalElements} results found for appInstanceId=${payload?.appInstanceId}`,
          status: `AppInstance roles retrieve successfully `,
          action: `Clicked appInstance roles `,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      }
        yield put(appRolesInstanceRoles(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_app_roles_instance_roles`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance roles `,
            action: `Search  appInstance roles`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
      const traceObj ={
        type: `get_app_roles_instance_roles`,
        event: 'click',
        message: `0 results found for appInstanceId=${payload?.appInstanceId}`,
        status: `Failed to retrieve appInstance roles`,
        action: `Clicked appInstance roles `,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
    }
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAppInstanceRolePermission() {
  yield takeEvery(GET_APP_INSTANCE_ROLE_PERMISSIONS, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const query =localStorage.getItem("query");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRolePermissons?appInstanceRoleId=${
          payload?.appInstanceRoleId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_app_instance_role_permissions`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
              status: `AppInstance role permissions retrieve successfully `,
              action: `Search appInstance role permissions`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_app_instance_role_permissions`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for appInstanceId=${payload?.appInstanceId}`,
              status: `AppInstance role permissions retrieve successfully `,
              action: `Clicked appInstance role permissions `,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        yield put(appInstanceRolePermissions(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_app_instance_role_permissions`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance role permissions`,
            action: `Search appInstance role permissions`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_instance_role_permissions`,
            event: 'click',
            message: `0 results found for appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance role permissions`,
            action: `Clicked app instance role permissions list`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAppInstanceRolePermissionsList() {
  yield takeLatest(GET_APP_INSTANCE_ROLE_PERMISSIONS_LIST, function* ({ payload }) {
    const userId = localStorage.getItem("id");
    const accountId = localStorage.getItem("accountId");
    const {query } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/appInstanceRolePermissonsList?appInstanceRoleId=${
          payload?.appInstanceRoleId
        }&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_app_instance_role_permissions_list`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
              status: `AppInstance role permissions list retrieve successfully `,
              action: `Search appInstance role permissions list`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
        const traceObj ={
          type: `get_app_instance_role_permissions_list`,
          event: 'click',
          message: `${res?.data?.totalElements} results found for appInstanceId=${payload?.appInstanceId}`,
          status: `AppInstance role permissions list retrieve successfully `,
          action: `Clicked app instance role permissions list`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      }
        yield put(appInstanceRolePermissions(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_app_instance_role_permissions_list`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance role permissions list`,
            action: `Search appInstance role permissions list`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_app_instance_role_permissions_list`,
            event: 'click',
            message: `0 results found for appInstanceId=${payload?.appInstanceId}`,
            status: `Failed to retrieve appInstance role permissions list`,
            action: `Clicked app instance role permissions list`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
    }
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAssignInstanceUserRoles() {
  yield takeEvery(GET_ASSIGN_INSTANCE_USER_ROLES, function* ({ payload }) {
    const { appInstanceId, accountUserId, appId } = payload;
    //  const accountId = localStorage.getItem("accountId");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: appInstanceId,
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/userRolesList?appInstanceId=${appInstanceId}&appId=${appId}&accountUserId=${accountUserId}`,
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `get_assign_instance_user_roles`,
          event: 'click',
          message: `Assign instance user roles successfully  For appId=${appId} and appInstanceId=${appInstanceId} and accountUserId=${accountUserId}`,
          status: `Assign instance user roles successfully `,
          action: `Clicked get assign instance user roles`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        yield put(appInstanceUserRoles(res.data));
      }
    } catch (err) {
      const traceObj ={
        type: `get_assign_instance_user_roles`,
        event: 'click',
        message: ` Failed to assign instance user roles for appId=${appId} and appInstanceId=${appInstanceId} and accountUserId=${accountUserId}`,
        status: `Failed to assign instance user roles`,
        action: `Clicked get assign instance user roles`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* assignAppInstanceRoleToUser() {
  yield takeEvery(ASSIGN_APP_ROLE_TO_USER, function* ({ payload }) {
    try {
      const {
        appInstanceId,
        appId,
        accountUserId,
        checkedRoles,
        checkedDefaultRoles,
      } = payload;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      const userRolesList = {};
      userRolesList["accountUserId"] = accountUserId;
      userRolesList["appInstanceId"] = appInstanceId;
      userRolesList["appId"] = appId;
      userRolesList["checkedRoles"] = checkedRoles;
      userRolesList["checkedDefaultRoles"] = checkedDefaultRoles;
      userRolesList["userUpdated"] = localStorage.getItem("userId");
      userRolesList["userCreated"] = localStorage.getItem("userId");
      userRolesList["businessName"] = localStorage.getItem("businessName");
      const response = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/assignRolesToUser`,
        userRolesList,
        config
      );
      if (response.status === 200) {
        const traceObj ={
          type: `assign_roles_to_user`,
          event: 'click',
          message: `Assign roles to user successfully  For appId=${appId} and appInstanceId=${appInstanceId} and accountUserId=${accountUserId}`,
          status: `Assign roles to user successfully `,
          action: `Clicked get assign roles to user`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        Modal.success({
          title: t("impaqx.adminApp.appRoleAssignedUser"),
          icon: <CheckCircleFilled />,
          okText: t("impaqx.adminApp.close"),
          //cancelText: 'Cancel',
          onOk() {
            //deleteApp(id);
          },
        });
        yield put(appInstanceRoles(response.data));
      }
    } catch (err) {
      const traceObj ={
        type: `assign_roles_to_user`,
        event: 'click',
        message: `Failed to assign roles to user For appId=${payload?.appId} and appInstanceId=${payload?.appInstanceId} and accountUserId=${payload?.accountUserId}`,
        status: `Failed to assign roles to user`,
        action: `Clicked get assign roles to user`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err));
    }
  });
}

export function* setModalRolePopUp() {
  yield takeEvery(SET_MODAL_POPUP, function* ({ payload }) {
    yield put(setModalRolePopUpData(payload));
  });
}

export function* addAppSettingsReactJson() {
  yield takeEvery(ADD_APP_INSTANCE_SETTINGS_JSON, function* ({ payload }) {
    const { appInstanceId, settingsValues, customizeSettings} = payload;
    const id = appInstanceId;
    console.log("customizeSettings values", customizeSettings);
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    const customSettings=settingsValues?'settings':'custom settings';
    try {
      const res = settingsValues
        ? yield axios.put(
            `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${id}`,
            {
              [`settingsValues`]: settingsValues,
            },
            config
          )
        : yield axios.put(
            `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${id}`,
            {
              [`customSettings`]: customizeSettings,
            },
            config
          );
      if (res.status === 200) {
        const traceObj ={
          type: `add_app_${customSettings}`,
          event: 'click',
          message: `Added appInstance ${customSettings} for id=${id}`,
          status: `AppInstance ${customSettings} added aucessfully`,
          action: `Clicked add app ${customSettings}`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        // yield put(appSettingsJson(res.data));
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${payload?.appInstanceId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              "Access-Control-Allow-Origin": "*",
              Accept: "application/json",
              "Content-Type": "application/json",
              accountId: localStorage.getItem("accountId"),
              appInstanceId: payload?.appInstanceId,
              accountUserId: localStorage.getItem("accountUserId"),
            },
          }
        );

        if (response.status === 200) {
          if (response?.data !== null) {
            yield put(appSettingsJson(response.data));
          }
        }
        Modal.success({
          title: t("impaqx.adminApp.formConfigurationUpdateSuccessMessage"),

          icon: <CheckCircleFilled />,

          okText: t("impaqx.adminApp.close"),
        });
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_${customSettings}`,
        event: 'click',
        message: `Failed to add appInstance ${customSettings} for id=${id}`,
        status: `Failed to add app ${customSettings}`,
        action: `Clicked add app ${customSettings}`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);

      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* addConnectorSettingsReactJson() {
  yield takeEvery(
    ADD_CONNECTOR_INSTANCE_SETTINGS_JSON,
    function* ({ payload }) {
      const { appInstanceId, settingsSchema, settingsValues } = payload;
      const id = appInstanceId;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId"),
        },
      };
      try {
        const res = yield axios.put(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/settings/${id}`,
          {
            [`settingsValues`]: settingsValues,
          },
          config
        );

        if (res.status === 200) {
          const traceObj ={
            type: `add_connector_settings_json`,
            event: 'click',
            message: `Added connector settings for id=${id}`,
            status: ` Connector settings added successfully `,
            action: `Clicked add connector settings json`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
          yield put(connectorSettingsJson(res.data));
          Modal.success({
            title: t("impaqx.adminApp.formConfigurationUpdateSuccessMessage"),

            icon: <CheckCircleFilled />,

            okText: t("impaqx.adminApp.close"),
          });
        }
      } catch (err) {
        const traceObj ={
          type: `add_connector_settings_react_json`,
          event: 'click',
          message: `Failed to add connector settings for id=${id}`,
          status: ` Failed to add connector settings`,
          action: `Clicked add connector settings json`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        console.log(err);

        yield put(showAppInstanceMessage(err.response));
      }
    }
  );
}

export function* saveAppInstanceApiKey() {
  yield takeEvery(SAVE_APP_INSTANCE_API_KEY, function* ({ payload }) {
    const { apiKey } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-key`,
        apiKey,
        config
      );

      if (res.status === 200) {
        const traceObj ={
          type: `add_app_instance_api_keys`,
          event: 'click',
          message: `Added appInstanceKey with id=${res?.data?.id} and appInstanceId=${apiKey?.appInstanceId}`,
          status: ` AppInstanceKey added successfully `,
          action: `Clicked add appInstanceKey`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-keys?appInstanceId=${apiKey?.appInstanceId}`,
          config
        );
        if (response.status === 200) {
          yield put(appInstanceApiKeys(response.data));
        }
        yield put(appInstanceApiKey(response.data.appInstanceApiKey));

        Modal.success({
          title: `${apiKey.appName} Customer Api key saved successfully`,

          icon: <CheckCircleFilled />,

          okText: t("impaqx.adminApp.close"),
        });
      }
    } catch (err) {
      const traceObj ={
        type: `add_app_instance_api_keys`,
        event: 'click',
        message: `Failed to add appInstanceKey with appName=${apiKey?.appName} and appInstanceId=${apiKey?.appInstanceId}`,
        status: `Failed to add appInstanceKey`,
        action: `Clicked add appInstanceKey`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAppInstanceApiKey() {
  yield takeEvery(GET_APP_INSTANCE_API_KEY, function* ({ payload }) {
    const { appInstanceId } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-key?userId=${localStorage.getItem(
          "userId"
        )}&appInstanceId=${appInstanceId}`,
        config
      );

      if (res.status === 200) {
        const traceObj ={
          type: `get_app_instance_api_key`,
          event: 'click',
          message: `Fetch appInstance api key for userId=${localStorage.getItem("userId")} and appInstanceId=${appInstanceId}`,
          status: ` Fetched appInstance api keys successfully `,
          action: `Clicked get app instance api keys`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        yield put(appInstanceApiKey(res.data));
      }
    } catch (err) {
      const traceObj ={
        type: `get__app_instance_api_keys`,
        event: 'click',
        message: `Failed to fetch appInstance api key for userId=${localStorage.getItem("userId")} and appInstanceId=${appInstanceId}`,
        status: ` Failed to fetch appInstance api key`,
        action: `Clicked get app instance api keys`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);

      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* getAppInstanceApiKeys() {
  yield takeEvery(GET_APP_INSTANCE_API_KEYS, function* ({ payload }) {
    const { appInstanceId,query } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-keys?appInstanceId=${appInstanceId}&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}`,
        config
      );

      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
             type: `get_app_instance_api_keys`,
             event: 'click',
             message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
             status: ` Fetched appInstance api keys successfully `,
             action: `Clicked get app instance api keys`,
             referer_action_id: localStorage.getItem("referer_action_id"),
             trackId: uuidv4(),
             user_session: sessionStorage.getItem("user_session")
           };
           localStorage.setItem("referer_action_id",traceObj.trackId);
           trace({"traceObj":traceObj});
         }else{
           const traceObj ={
             type: `get_app_instance_api_keys`,
             event: 'click',
             message: `${res?.data?.totalElements} results found appInstanceId=${payload?.appInstanceId}`,
             status: ` Fetched appInstance api keys successfully `,
             action: `Clicked get app instance api keys`,
             referer_action_id: localStorage.getItem("referer_action_id"),
             trackId: uuidv4(),
             user_session: sessionStorage.getItem("user_session")
           };
           localStorage.setItem("referer_action_id",traceObj.trackId);
           trace({"traceObj":traceObj});
         }
        yield put(appInstanceApiKeys(res.data));
      }
    } catch (err) {
      if(query!==undefined && query!==""){
        const traceObj ={
           type: `get_app_instance_api_keys`,
           event: 'click',
           message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
           status: ` Failed to fetch appInstance api keys`,
           action: `Clicked get app instance api keys`,
           referer_action_id: localStorage.getItem("referer_action_id"),
           trackId: uuidv4(),
           user_session: sessionStorage.getItem("user_session")
         };
         localStorage.setItem("referer_action_id",traceObj.trackId);
         trace({"traceObj":traceObj});
       }else{
          const traceObj ={
            type: `get_app_instance_api_keys`,
            event: 'click',
            message: `0 results found for appInstanceId=${payload?.appInstanceId}`,
            status: ` Failed to fetch appInstance api keys`,
            action: `Clicked get app instance api keys`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(err);

      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* updateAppInstanceApiKey() {
  yield takeEvery(UPDATE_APP_INSTANCE_API_KEY, function* ({ payload }) {
    const { apiKey } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-key/${apiKey?.id}`,
        apiKey,
        config
      );

      if (res.status === 200) {
        const traceObj ={
          type: `update_app_instance_api_key`,
          event: 'click',
          message: `AppInstance api key updated successfully  for id=${apiKey?.id} and appInstanceId=${apiKey.appInstanceId}`,
          status: ` App Instance Api Key Updated successfully `,
          action: `Clicked update app instance api key`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        Modal.success({
          title: `${apiKey.appName}  Customer Api key updated successfully`,

          icon: <CheckCircleFilled />,

          okText: t("impaqx.adminApp.close"),
        });
        const res = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-keys?appInstanceId=${apiKey?.appInstanceId}`,
          config
        );
  
        if (res.status === 200) {
          yield put(appInstanceApiKeys(res.data));
        }
        yield put(appInstanceApiKey(res.data));
      }
    } catch (err) {
      const traceObj ={
        type: `update_app_instance_api_key`,
        event: 'click',
        message: `Failed to update appInstance api key for id=${apiKey?.id} and appInstanceId=${apiKey.appInstanceId}`,
        status: ` Failed to update appInstance api key`,
        action: `Clicked update app instance api key`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);

      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* deleteAppInstanceApiKey() {
  yield takeEvery(DELETE_APP_INSTANCE_API_KEY, function* ({ payload }) {
    const { apiKey } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.delete(
        `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-key/${apiKey?.id}`,
        config
      );

      if (res.status === 200) {
        const traceObj ={
          type: `delete_app_instance_api_key`,
          event: 'click',
          message: `AppInstance api key deleted successfully  for id=${apiKey?.id}`,
          status: ` AppInstance api key deleted successfully `,
          action: `Clicked delete app instance api key`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        const res = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/app-instance-api-keys?appInstanceId=${apiKey?.appInstanceId}`,
          config
        );
  
        if (res.status === 200) {
          Modal.success({
            title: `${apiKey.appName} Customer Api key deleted successfully`,
  
            icon: <CheckCircleFilled />,
  
            okText: t("impaqx.adminApp.close"),
          });
          yield put(appInstanceApiKeys(res.data));
        }
        yield put(appInstanceApiKey(res.data));
      }
    } catch (err) {
      const traceObj ={
        type: `delete_app_instance_api_key`,
        event: 'click',
        message: `Failed to delete appInstance api key for id=${apiKey?.id}`,
        status: ` Failed to delete appInstance api key `,
        action: `Clicked delete app instance api key`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);

      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* addUiInstancePropertiesData() {
  yield takeEvery(ADD_APP_INSTANCE_UI_PROPERTIES, function* ({ payload }) {
    const {
      appInstanceId,
      editableProp,
      query,
      sortField,
      sortorder,
      pagination,
      sorter,
    } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    console.log(editableProp);
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/ui-properties/${appInstanceId}`,
        { ["uiPropertyValues"]: JSON.stringify(editableProp) },
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `add_ui_instance_properties_data`,
          event: 'click',
          message: `Ui instance properties data added successfully  for appInstanceId=${payload?.appInstanceId}`,
          status: ` Ui instance properties data added successfully `,
          action: `Clicked add ui instance properties data`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/ui-properties/${appInstanceId}?query=${
            query ?? ""
          }&sortfield=${sorter?.field ?? sortField ?? ""}&sortorder=${
            sorter?.order ?? sortorder ?? ""
          }&page=${(pagination?.current ?? 1) - 1}&size=${
            pagination?.pageSize ?? 10
          }&useMongo=true`,
          config
        );
        if (response.status === 200) {
          yield put(appInstanceUiPropertiesJson(response?.data));
        }
        Modal.success({
          title: t("impaqx.adminApp.propertySaveMessage"),
          icon: <ExclamationCircleOutlined />,
          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `add_ui_instance_properties_data`,
        event: 'click',
        message: `Failed to add ui instance properties data for appInstanceId=${payload?.appInstanceId}`,
        status: `Failed to add ui instance properties data`,
        action: `Clicked add ui instance properties data`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}
export function* getInstanceUiPropertiesDetails() {
  yield takeEvery(APP_INSTANCE_UI_PROPERTIES, function* ({ payload }) {
    const { appId, query, sortField, sortorder } = payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const res = yield axios.get(
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/app-ui-properties?appInstanceId=${payload?.appInstanceId}&query=${query}&sortfield=${sortField}&sortorder=${sortorder}`,
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/ui-properties/${payload?.appInstanceId}?query=${query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}&useMongo=true`,
        config
      );
      if (res.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_instance_ui_properties_details`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
              status: `Fetched instance ui properties details successfully `,
              action: `Search instance ui properties detail`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_instance_ui_properties_details`,
              event: 'click',
              message: `${res?.data?.totalElements} results found for and appInstanceId=${payload?.appInstanceId}`,
              status: ` Fetched instance ui properties details successfully `,
              action: `Clicked instance ui properties details`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        yield put(appInstanceUiPropertiesJson(res?.data));
      }
    } catch (error) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_instance_ui_properties_details`,
            event: 'click',
            message: `0 results found for keyword=${payload?.query} and appInstanceId=${payload?.appInstanceId}`,
            status: `Failed To Fetched Instance Ui Properties Details`,
            action: `Search instance ui properties detail`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `get_instance_ui_properties_details`,
            event: 'click',
            message: `0 result found for appInstanceId=${payload?.appInstanceId}`,
            status: ` Failed to fetched instance ui properties details`,
            action: `Clicked instance ui properties details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(error);
      yield put(showAppInstanceMessage(error?.response));
    }
  });
}

export function* deleteUiInstancePropertiesData() {
  yield takeEvery(DELETE_APP_INSTANCE_UI_PROPERTIES, function* ({ payload }) {
    const { appInstanceId, editableProp, query, sortField, sortorder } =
      payload;
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountd"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    console.log(editableProp);
    try {
      const res = yield axios.put(
        `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/ui-properties/${appInstanceId}`,
        { ["uiPropertyValues"]: JSON.stringify(editableProp) },
        config
      );
      if (res.status === 200) {
        const traceObj ={
          type: `delete_ui_instance_properties_data`,
          event: 'click',
          message: `Ui instance properties data deleted for appInstanceId=${appInstanceId}`,
          status: ` Ui instance Properties data deleted`,
          action: `Clicked delete ui instance properties data`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        const response = yield axios.get(
          `${API_BASE_DEVELOPER_APP}/developerApp/accountAppInstance/ui-properties/${payload?.appInstanceId}?query=${query}&sortfield=${sortField}&sortorder=${sortorder}`,
          config
        );
        //`${API_BASE_DEVELOPER_APP}/developerApp/properties/ui-proerties?appId=${appId}&query=${query}&sortfield=${sortField}&sortorder=${sortorder}`,
        if (response.status === 200) {
           yield put(appInstanceUiPropertiesJson(response?.data));
        }
        Modal.success({
          title: t("impaqx.adminApp.uiPropertyDeleteMessage"),
          icon: <ExclamationCircleOutlined />,
          okText: "Close",
        });
      }
    } catch (err) {
      const traceObj ={
        type: `delete_ui_instance_properties_data`,
        event: 'click',
        message: `Failed to delete ui instance properties data for appInstanceId=${appInstanceId}`,
        status: `Failed to delete ui instance properties data  `,
        action: `Clicked delete ui instance properties data`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err.response));
    }
  });
}

export function* linkAppToConnector() {
  yield takeEvery(LINK_APP_TO_CONNECTOR, function* ({ payload }) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId"),
      },
    };
    try {
      const { connectorId, accountId, appInstanceId, status } = payload;
      const data = {};
      data["appInstanceId"] = appInstanceId;
      data["accountId"] = accountId;
      data["userCreated"] = localStorage.getItem("userId");
      data["userUpdated"] = localStorage.getItem("userId");
      data["connectorAppInstanceId"] = connectorId;
      data["status"] = status;
      const response = yield axios.post(
        `${API_BASE_DEVELOPER_APP}/developerApp/link-connector-app`,
        data,
        config
      );
      if (response.status === 200) {
        const traceObj ={
          type: `${payload?.status=='ACTIVE'?'link':'unlink'}_app_to_connector`,
          event: 'click',
          message: `App ${payload?.status=='ACTIVE'?'link':'unlink'} to connector successfully `,
          status: ` App ${payload?.status=='ACTIVE'?'link':'unlink'} to connector successfully `,
          action: `Clicked ${payload?.status=='ACTIVE'?'link':'unlink'} app to connector`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        var title = "Connector linked to app successfully";
        if (status == "INACTIVE") {
          title = "Connector removed from the app successfully";
        }
        Modal.success({
          title: title,
          icon: <CheckCircleFilled />,
          okText: "Close",
        });
        yield put({
          type: GET_LINKED_APP_INSTANCE_CONNECTOR,
          payload: { appInstanceId },
        });
      }
    } catch (err) {
      const traceObj ={
        type: `${payload?.status=='ACTIVE'?'link':'unlink'}_app_to_connector`,
        event: 'click',
        message: `Failed to ${payload?.status=='ACTIVE'?'link':'unlink'} app to connector`,
        status: ` Failed to ${payload?.status=='ACTIVE'?'link':'unlink'} app to connector`,
        action: `Clicked ${payload?.status=='ACTIVE'?'link':'unlink'} app to connector`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(err);
      yield put(showAppInstanceMessage(err?.response));
    }
  });
}

export function* getAppInstanceConnectorDetails() {
  yield takeEvery(GET_APP_INSTANCE_CONNECTOR_DETAILS, function* ({ payload }) {
    const {query } = payload;
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/services?accountId=${localStorage.getItem(
          "accountId"
        )}&query=${payload?.query}&sortfield=${
          payload?.sorter?.field
        }&sortorder=${payload?.sorter?.order}&page=${
          payload?.pagination?.current - 1
        }&size=${payload?.pagination?.pageSize}=`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            accountId: localStorage.getItem("accountId"),
            appInstanceId: payload?.appInstanceId,
            accountUserId: localStorage.getItem("accountUserId"),
          },
        }
      );

      if (response.status === 200) {
        if(query!==undefined && query!==""){
          const traceObj ={
              type: `search_app_instance_connector_details`,
              event: 'click',
              message: `Fetched appInstance connector details for keyword=${payload?.query} and accountId=${localStorage.getItem(
                "accountId"
              )}`,
              status: `Fetched appInstance connector details successfully `,
              action: `Search appInstance connector details`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }else{
            const traceObj ={
              type: `get_app_instance_connector_details`,
              event: 'click',
              message: `Fetched app instance connector details for accountId=${localStorage.getItem(
                "accountId"
              )}`,
              status: ` Fetched appInstance connector details successfully `,
              action: `Clicked appInstance connector details`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          }
        if (response?.data !== null) {
          yield put(appInstaneData(response.data));
        }
      }
    } catch (error) {
      if(query!==undefined && query!==""){
        const traceObj ={
            type: `search_app_instance_connector_details`,
            event: 'click',
            message: ` Failed to fetched appInstance connector details for keyword=${payload?.query} and accountId=${localStorage.getItem(
              "accountId"
            )}`,
            status: ` Failed to fetched appInstance connector details`,
            action: `Search appInstance connector details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }else{
          const traceObj ={
            type: `add_ui_properties_data`,
            event: 'click',
            message: `Failed to fetched appInstance connector details for accountId=${localStorage.getItem(
              "accountId"
            )}`,
            status: ` Failed to fetched appInstance connector details`,
            action: `Clicked appInstance connector details`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
          };
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        }
      console.log(error);

      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export function* getLinkedAppInstanceConnectorDetails() {
  yield takeEvery(GET_LINKED_APP_INSTANCE_CONNECTOR, function* ({ payload }) {
    const { appInstanceId } = payload;
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/link-connectors-app?appInstanceId=${appInstanceId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            accountId: localStorage.getItem("accountId"),
            appInstanceId: payload?.appInstanceId,
            accountUserId: localStorage.getItem("accountUserId"),
          },
        }
      );

      if (response.status === 200) {
        const traceObj ={
          type: `get_linked_app_instance_connector_details`,
          event: 'click',
          message: `Linked appInstance connector details fetched successfully  for appInstanceId=${appInstanceId}`,
          status: ` Linked appInstance connector details fetched successfully `,
          action: `Clicked get linked app instance connector details`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
        };
        localStorage.setItem("referer_action_id",traceObj.trackId);
        trace({"traceObj":traceObj});
        if (response?.data !== null) {
          yield put(linkedAppInstaneData(response.data));
        }
      }
    } catch (error) {
      const traceObj ={
        type: `get_linked_app_instance_connector_details`,
        event: 'click',
        message: `Failed to retrieve linked appInstance connector details for appInstanceId=${appInstanceId}`,
        status: ` Failed to retrieve linked appInstance connector details`,
        action: `Clicked get linked app instance connector details`,
        referer_action_id: localStorage.getItem("referer_action_id"),
        trackId: uuidv4(),
        user_session: sessionStorage.getItem("user_session")
      };
      localStorage.setItem("referer_action_id",traceObj.trackId);
      trace({"traceObj":traceObj});
      console.log(error);

      yield put(showAppInstanceMessage(error.response));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getApplicationSettingsDetail),
    fork(getConnectorSettingsDetail),
    fork(getAppInstanceDetails),
    fork(addAppInstanceRole),
    fork(deleteAppRole),
    fork(getAppInstanceRoles),
    fork(getAppRolesInstanceRoles),
    fork(getAppInstanceRolePermission),
    fork(updateAppInstanceRole),
    fork(assignAppInstanceRoleToUser),
    fork(setModalRolePopUp),
    fork(addAppSettingsReactJson),
    fork(addConnectorSettingsReactJson),
    fork(saveAppInstanceApiKey),
    fork(getAppInstanceApiKey),
    fork(getAssignInstanceUserRoles),
    fork(addUiInstancePropertiesData),
    fork(getInstanceUiPropertiesDetails),
    fork(deleteUiInstancePropertiesData),
    fork(getAppInstanceConnectorDetails),
    fork(linkAppToConnector),
    fork(getLinkedAppInstanceConnectorDetails),
    fork(getAppInstanceRolePermissionsList),
    fork(getAppInstanceApiKeys),
    fork(deleteAppInstanceApiKey),
    fork(updateAppInstanceApiKey)
  ]);
}
